/*******************************************************************************
Clear The Search Box In Side Nav
Clear the section search box and show all the pages.
*******************************************************************************/

// Clear the section search box and show all the pages.
export default function clearSectionSearch() {
    if ($('.side-nav__search').length === 0) { return; }

    // Clear the search input box and hide the clear button
    $('.side-nav__search').val('').next('.side-nav__clear-search').addClass('hide');

    // Show all the pages and sub-section titles in the section
    $('.side-nav__item').removeClass('hide');
    $('.side-nav__sub-section').removeClass('hide');

    // Remove the "No Pages Found" message
    $('.side-nav__no-results').remove();

    // Make sure the menu is scrolled all the way to the top to start (possible performance issue?)
    //$('.side-nav__middle').scrollTop(0);

    // Remove the search class from the nav
    $('.side-nav').removeClass('is-search');

    // Compress all the sub nav groups
    $('.side-nav__group').removeClass('is-open is-search-result');
}
